import { render, staticRenderFns } from "./inventoryOrderForm.vue?vue&type=template&id=bdb2b93a&scoped=true&"
import script from "./inventoryOrderForm.vue?vue&type=script&lang=js&"
export * from "./inventoryOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOrderForm.vue?vue&type=style&index=0&id=bdb2b93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb2b93a",
  null
  
)

export default component.exports